import { WebworkerType } from "./webworker-type.ts";

const resolvers = new Map();
const callbackMethodsById = new Map();

export const createWebworker = <T extends WebworkerType>(url : string | URL, options : any) => new Promise<T & Worker>((resolve) => {
    let registeredMethods : string[] = [];

    const worker = new Worker(url, options);

    const proxy = new Proxy(worker, {
        get(target, property : string, receiver) {
            if(registeredMethods.includes(property)) {
                return (...params : any[]) => {
                    const resolverId = crypto.randomUUID();
                    worker.postMessage({ type: "WebworkerMethodCall", methodName: property, params: serializeParams(params), resolverId } )
                    return new Promise(resolve => resolvers.set(resolverId, resolve));
                }
            }

            const value =  Reflect.get(target, property, receiver);

            if (value instanceof Function) {
                return value.bind(target);
            }
            
            return value;
        }
    });

    worker.addEventListener("message", (event) => {
        //console.log("main", event.data);
        switch(event.data.type) {
            case "WebworkerReady":
                registeredMethods = event.data.methods;
                resolve(proxy as T & Worker);
                break;

            case "WebworkerMethodResponse":
                if(event.data?.response?.type === "WebworkerCallbackReference") {
                    const response = () => worker.postMessage({ type: "WebworkerCallback", callbackId: event.data.response.callbackId, params: [] });
                    resolvers.get(event.data.resolver)?.(response);
                    resolvers.delete(event.data.resolver);
                } else {
                    resolvers.get(event.data.resolver)?.(event.data.response);
                    resolvers.delete(event.data.resolver);
                }
                break;

            case "WebworkerCallback":
                const callback = callbackMethodsById.get(event.data.callbackId);

                if(callback) {
                    callback(...event.data.params);
                }
                break;

            case "UnregisterCallback":
                callbackMethodsById.delete(event.data.callbackId);
                break;
        }
    });
})

const serializeParams = (params : any[]) => params.map(param => {
    if(param instanceof Function) {
        const callbackId = crypto.randomUUID();
        callbackMethodsById.set(callbackId, param);

        return {
            type: "WebworkerCallbackReference",
            callbackId
        }
    }

    return param;
})